import accountsApi from '@/api/accounts';
import profileApi from '@/api/profile';
import apiService from '@/api';

const storageToken = localStorage.getItem('token') || '';
let userData = {};
if (storageToken.split('.')[1]) userData = JSON.parse(atob(storageToken.split('.')[1]));


export default {
  namespaced: true,
  state: {
    status: '',
    token: storageToken,
    user: userData,
    profile: {},
  },
  actions: {
    login({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        accountsApi
          .login(user)
          .then((resp) => {
            dispatch('loginSuccess', resp);
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },
    async loginSuccess({ commit, dispatch }, resp) {
        const token = resp.token || resp.access;
        localStorage.setItem('token', token);
        commit('auth_success', token);
    
        const profile = await dispatch('loadProfile');
        dispatch('loadCompany');
    
        return profile;
    },
    loadCompany({ commit }) {
      profileApi.getCompany().then((res) => {
        commit('setCompany', res);
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        localStorage.removeItem('token');
        delete apiService.defaults.headers.common.Authorization;
        resolve();
      });
    },
    async loadProfile({ commit }) {
        const res = await profileApi.get();
        commit('setProfile', res);
        return res;
    },
    updateProfile({ commit }, user) {
      return new Promise((resolve, reject) => {
        profileApi
          .update(user)
          .then((resp) => {
            //const { token } = resp;
            //localStorage.setItem('token', token);
            commit('setProfile', resp);
            resolve(resp);
          })
          .catch((err) => {
            //localStorage.removeItem('token');
            reject(err);
          });
      });
    },
    setDefaultCompany({commit}, company_id) {
      return new Promise((resolve, reject) => {
        profileApi
          .setDefaultCompany(company_id)
          .then((resp) => {
            commit('setDefaultCompany', company_id);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, token) {
      if (typeof token !== 'string' || token === '') {
          console.error('Invalid token:', token);
          return;
      }
      state.status = 'success';
      state.user = JSON.parse(atob(token.split('.')[1]));
      state.token = token;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.token = '';
      state.user = {};
    },
    setProfile(state, profile) {
      state.profile = profile;
    },
    setCompany(state, company) {
      state.company = company;
    },
    setDefaultCompany(state, company_id) {
      state.profile.default_ocr_company = company_id
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    profile: (state) => state.profile,
    company: (state) => state.company,
  },
};